import "../App.css";
import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

import { useInView } from "react-intersection-observer";

const FadeInTitle = ({ children }) => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

    return (
        <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
            {children}
        </p>
    );
};

const Lost = () => {
    return (
        <div className="App">
            <Helmet>
                <title>Heartland Fun: Unknown Page</title>
                <meta name="title" content="Heartland Fun: Unknown Page" />
                <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
                <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
                <meta name="robots" content="index, follow" />
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="language" content="English" />
                <meta property="og:title" content="Heartland Fun: Unknown Page" />
                <meta property="og:type" content="website" />
                <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
                <meta property="og:determiner " content="" />
                <meta property="og:url" content="https://heartland.csfrederick.com/404" />
                <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
                <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
                <link rel="icon" href="/favicon.ico" />
            </Helmet>
            <Navbar></Navbar>
            <Warning></Warning>
            <FadeInTitle>DESTINATION NOT FOUND</FadeInTitle>
            <br></br>
            <a href="/" className="Button Titillium Center">
                Go Back Home
            </a>
            <p className="Blue InfoText Titillium Center FadeIn">
                The link you requested was not found on the server. Check for typos and try again. If you clicked a button and got here, the page you requested is currently down for maintenance.
            </p>
            <Footer></Footer>
        </div>
    );
}


export default Lost;